__turbopack_context__.v({
  "className": "gilda_display_a844ec1c-module__JGxPpW__className",
});
